import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

export type ProjectPhase = {
  projectPhaseId: string;
  organisationId: string;
  phaseName: string;
};

export type ProjectPhasesResponse = ResponseType<ProjectPhase[]>;

function useAllProjectPhasesQuery(enabled = true) {
  return useQuery<
    AxiosResponseAndError<ProjectPhasesResponse>["response"],
    AxiosResponseAndError<ProjectPhasesResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.projectPhases],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.project + "/project-phases"),
    enabled: enabled,
    staleTime: 60000,
  });
}

export default useAllProjectPhasesQuery;
